import {
  Target,
  BarChart3,
  TrendingUp,
  ListTodo,
} from 'lucide-react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { HubShell } from '@/components/layout/HubShell';
import FocusModePage from './FocusModePage';
import { GoalsPage } from './GoalsPage';
import { HabitTracking } from './HabitTracking';
import { DragDropPage } from './DragDropPage';

/**
 * Productivity hub — focus, timers, goals, habits, and blocking tools.
 */
export function ProductivityHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const sec = searchParams.get('section');
    if (sec === 'block' || sec === 'pomodoro' || sec === 'time') {
      const next = new URLSearchParams(searchParams);
      next.set('section', 'focus');
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const tabs = [
    { id: 'focus', label: 'Focus & Timer', icon: Target, render: () => <FocusModePage /> },
    { id: 'goals', label: 'Goals', icon: BarChart3, render: () => <GoalsPage /> },
    { id: 'habits', label: 'Habits', icon: TrendingUp, render: () => <HabitTracking /> },
    { id: 'drag', label: 'Drag & Drop', icon: ListTodo, render: () => <DragDropPage /> },
  ];

  return (
    <HubShell
      title="Productivity"
      description="Focus, time-track, and reach your goals."
      icon={Target}
      tabs={tabs}
      defaultSection="focus"
    />
  );
}

export default ProductivityHubPage;
